module.exports = __webpack_public_path__ + "static/epa-f39eb0a2fa5e1c2a08b03c8e5495e597.png";